export const Company = [
    {
      id: "1",
      enable:1,
      code: "C001",
      name: "Las Ventanas",
    },
    {
      id: "2",
      enable:1,
      code: "C002",
      name: "Saepe Eveniet",
    },
    {
      id: "3",
      enable:1,
      code: "C003",
      name: "Voluptates Repudiandae",
    },
  ];